import { WorkerForWork } from '@types';
import { defaultCheckedInIndicator } from 'shared/components/shift-detail-modal/components/tabs/shared/types/shift-detail-tables.types';
import { FlexworkerColumnDefinition } from '../flex-workers-for-work-table.types';

export const getFlexworkerTableData = (
  flexWorkers: WorkerForWork[],
  entityId: string
): FlexworkerColumnDefinition[] => {
  return flexWorkers.map((fw) => {
    return {
      ...fw,
      flexWorkerImage: {
        ...fw.flexWorkerImage,
        id: fw.flexWorkerId,
        employmentType: fw.employmentType,
        includeCheckedInIndicator:
          fw.flexWorkerImage.includeCheckedInIndicator ?? defaultCheckedInIndicator,
      },
      actions: {
        entityId,
        flexWorkerId: fw.flexWorkerId,
        flexWorkerName: fw.flexWorkerFullName,
        partnerId: fw.partnerId,
      },
      availability: fw.availability,
      experienceInMonths: fw.experienceInMonths,
      contractHoursData: {
        workedMinutes: fw.workedMinutes ?? null,
        contractMinutes: fw.contractMinutes ?? null,
      },
    };
  });
};
